import { render } from "./ProfitSection.vue?vue&type=template&id=2f79c759&scoped=true"
import script from "./ProfitSection.vue?vue&type=script&lang=js"
export * from "./ProfitSection.vue?vue&type=script&lang=js"

import "./ProfitSection.vue?vue&type=style&index=0&id=2f79c759&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f79c759"]])

export default __exports__